<template>
  <ul class="list-group">
    <li class="" v-for="(ele, idx) in bookingItems" v-if="ele.name">
      <span class="texto-destacado titleRefugioResumen" v-text="ele.name"></span>, {{idioma.para}} <span
      class="texto-destacado"
      v-text="ele.persons"></span> {{idioma.personas}}<br/>{{idioma.entrada}}
      <span class="texto-destacado titleFechaResumen">{{ele.humanCheckIn}}</span>
      , {{idioma.salida}} <span
      class="texto-destacado titleFechaResumen">{{ele.humanCheckOut }}</span>
      <button @click="quitarRefugio(idx)" ><i class="fa fa-trash"></i></button>
    </li>
  </ul>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'
  import {refugeService} from "../../_services";
  import {refugesHelper} from "../../_helpers";
  export default {
    name: "booking-summary",
    props:['idioma'],
    created(){
      console.log(this.idioma)
    },
    data(){
      return {
        refugios:[],
      }
    },
    computed: {
      bookingItems(){
        return this.getBooking().items
      }
    },
    methods:{
      ...mapGetters(['getBooking','findRefuge']),
      ...mapMutations(['removeRefuge']),
      quitarRefugio(id){
        const _ref = this.findRefuge(id)
        let _rese = []
        _rese = {reservas:[_ref.booking]}

        const _toSend = refugesHelper.prepareToSend(_rese,'borrar')
        refugeService.removeRefuge(_toSend).then((a) => {
          this.removeRefuge(id)
          // Si se quitan todos los refugios se cancela la reserva
          if(this.getBooking().items.length === 0) this.$emit('cancelBooking')
        })
        //const a = this.removeRefuge(id)
        this.$emit('deleteRef')
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/shared/BookingSummary.vue